import { ReactNode } from 'react';

import './styles.scss';

type EllipsisComponentProps = {
  children: ReactNode;
  maxWidth?: number | string;
};

export const EllipsisComponent = ({
  children,
  maxWidth = '100%',
}: EllipsisComponentProps) => (
  <div
    style={{
      maxWidth,
    }}
  >
    <p className='cj-ellipsis'>{children}</p>
  </div>
);
